<template>
  <div>
    <vs-popup title="Leia o QRCode" :active.sync="isPopupActive" v-on:close="closeCallback" class="sizePopup">
      <div class="w-full flex justify-center items-center pt-4 pb-4">
        <vs-alert
            title="Aviso"
            active="true"
            color="warning"
            style="height: auto"
        >
          <div class="flex justify-center items-center">
            <span>Quer uma conexão que nunca cai? Conheça a integração oficial do WhatsApp!</span>
            <vs-button
                color="rgb(62, 201, 214)"
                type="filled"
                class="align-right"
                @click.prevent="openBuyApiCloudPopUp()"
            >
              <span>Quero Conhecer</span>
            </vs-button>
          </div>
        </vs-alert>
      </div>
      <div class="w-full flex justify-center items-center pt-4 pb-4">
        <vs-alert title="Orientação" active="true" color="primary" style="height: auto">
          Depois de apertar em 'Pedir QR Code' aguarde até ele ser gerado pela plataforma.
        </vs-alert>
      </div>

      <div class="w-full flex justify-center items-center pt-4 pb-4">
        <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">
          <span v-if="!resetFinished">Sua conexão está sendo resetada...</span>
          <div class="vs-con-loading__container" id="button-loading">
            <vs-button
              color="rgb(62, 201, 214)"
              type="filled"
              class="align-right"
              @click.prevent="getQrCode()"
              :disabled="!resetFinished || loadingQr"
            >
              <span>Pedir QR Code</span>
            </vs-button>
          </div>
        </div>
      </div>
      <div class="w-full">
        <ol>
          <li class="mb-2">
            1 - Abra o WhatsApp no celular e toque no ícone
            <feather-icon
              icon="MoreVerticalIcon"
              svgClasses="w-5 h-5 stroke-current"
            />
          </li>

          <li class="mb-2">
            2 - Selecione a opção <strong>Aparelhos conectados</strong>
          </li>

          <li class="mb-2">
            3 - Selecione a opção <strong>CONECTAR UM APARELHO</strong>
          </li>

          <li class="mb-2">
            4 - Aponte a câmera do seu celular para o QRCode abaixo
          </li>
        </ol>

        <div class="mt-3 mb-3 vs-con-loading__container" id="div-with-loading">
          <img v-if="wppQrCode && resetFinished" :src="wppQrCode" width="100%" height="100%" />
        </div>
      </div>
      <div class="w-full flex justify-center items-center pt-4 pb-4">
        <div class="w-6/12 flex justify-center items-center" style="flex-direction: column;">

          <span v-if="!resetFinished">Sua conexão está sendo resetada...</span>
          <div class="vs-con-loading__container" id="button-loading-reset">
            <vs-button
              color="rgb(62, 201, 214)"
              type="filled"
              class="align-right"
              @click.prevent="deletePopup = true;"
              :disabled="!resetFinished || loadingQr"
            >
              <span>Resetar Conexão</span>
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Resetar Conexão" :active.sync="deletePopup" class="top-component">
      <p class="mb-5">
        Caso você clique em "Continuar", nós vamos limpar sua conexão com o celular e reiniciar sua integração com o
        WhatsApp através do {{ appTitle }}.
      </p>
      <p><strong>Você deve aguardar o carregamento e após a conclusão solicitar um novo QR Code.</strong></p><br>

      <hr/>

      <vs-row
        vs-align="flex-end"
        vs-type="flex"
        vs-justify="flex-end"
        vs-w="12"
        class="mt-5"
      >
        <vs-button color="dark" type="flat" class="mr-3" @click="deletePopup = false">
          Cancelar
        </vs-button>

        <vs-button color="rgb(62, 201, 214)" type="filled" @click="resetPlugin">
          Continuar
        </vs-button>
      </vs-row>
    </vs-popup>
    <buy-api-cloud-pop-up
      :is-active="buyApiCloudPopUp"
      @isActiveFalse="closeBuyApiCloudPopUp"
    ></buy-api-cloud-pop-up>
  </div>
</template>

<script>

import { default as instanceApis } from '@/http/requests/instance'
import moduleSettings from '@/store/settings/moduleSettings'
import moduleInstance from '@/store/instance/moduleInstance'
import Vue from '@/main'
import { getCurrentTenant } from '@/utils'
import BuyApiCloudPopUp from "./BuyApiCloudPopUp";

export default({
  data(){
    return {
      open: false,
      wppQrCode: null,
      loadingQr: false,
      deletePopup: false,
      resetFinished: true,
      timeOutDetected: false,
      buyApiCloudPopUp: false
    }
  },
  props: ['isPopupActive', 'closeCallback'],
  components: { BuyApiCloudPopUp },
  methods: {
    openBuyApiCloudPopUp() {
      this.buyApiCloudPopUp = true
    },
    closeBuyApiCloudPopUp() {
      this.buyApiCloudPopUp = false
    },
    async getQrCode() {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 0.6
      })

      this.wppQrCode = '';
      this.loadingQr = true;
      await instanceApis.updatePhoneNumber(this.instance)

      this.$store.dispatch("settings/fetchWppQrCode", this.instance.id)
        .then(res => {
          this.timeOutDetected = false
          this.wppQrCode = res.data.data.changeWppQrCode.qr_code
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
        })
        .catch(error => { 
          const { response } = error
          if (
              this.timeOutDetected === false && 
              response.data.errors[0].message.includes('timed out') 
          ){
            this.getQrCode()
            console.error(error)
            this.timeOutDetected = true
          }
        })
    },
    resetPlugin() {
      instanceApis.restartInstancePlugin(this.instance.id).then(() => {
        this.wppQrCode = '';
        this.timeOutDetected = false;
        this.resetFinished = false;
        this.deletePopup = false;
        this.$vs.notify({
          color: 'success',
          title: 'Sucesso!',
          text: 'Conexão reiniciada com sucesso.'
        })
      })
    },
  },
  created() {  
    if (!moduleInstance.isRegistered) {
      this.$store.registerModule('instance', moduleInstance)
      moduleInstance.isRegistered = true
    }

    if (!moduleSettings.isRegistered) {
      this.$store.registerModule('settings', moduleSettings)
      moduleSettings.isRegistered = true
    }

    Vue.$events.on('InstanceUpdated', (event) => {
      if (event.tenantName === getCurrentTenant() && this.instance && this.instance.id === event.instance.id) {
        if (event.instance.activated && !event.isOnboarding) {
          this.closeCallback();
          return;
        }

        this.resetFinished = event.instance.reset_finished
        this.wppQrCode = event.instance.qr_code
      }
    })
  },
  computed: {
    appTitle() {
      return process.env.VUE_APP_APP_TITLE;
    },
    instance() {
      return this.$store.state.instance.selectedInstanceObject 
    }
  },
  watch: {
    resetFinished: function (val) {
      if (!val) {
        this.$vs.loading({
          container: '#button-loading',
          scale: 0.6
        })
        this.$vs.loading({
          container: '#button-loading-reset',
          scale: 0.6
        })

        return;
      }

      this.$vs.loading.close('#button-loading > .con-vs-loading')
      this.$vs.loading.close('#button-loading-reset > .con-vs-loading')
      this.wppQrCode = ''
    },
    isPopupActive: function (val) {
      this.wppQrCode = '';
      this.loadingQr = false;
      this.resetFinished = this.instance.reset_finished
      if (!val) {
        this.closeCallback()
      }
    },
    loadingQr(value){
      if (value){
        setTimeout(() => {
          this.loadingQr = false
        }, 5000)
      }
    }
  }
})
</script>

<style type="text/css">
  .top-component {
    z-index: 9999999999;
  }
</style>